import { FC, ReactNode, useRef } from "react";
import { APP_CONFIG } from "../../constants/constants";

type SelectFileInputProps = {
    id: string;
    label: ReactNode | string;
    onChange?: (file: File | null) => void;
    error?: string;
    showErrorValue?: boolean;
    disabled?: boolean;
    customInputClass?: string;
    customWrapperClass?: string;
    buttonDimensionClass?: string;
    allowedFields?: string[];
};

export const SelectFileInput: FC<SelectFileInputProps> = ({
    id,
    label,
    onChange,
    error,
    allowedFields,
    disabled = false,
    showErrorValue = true,
    customInputClass = "",
    customWrapperClass = "col-span-6",
    buttonDimensionClass = "h-10 w-full px-4",
}) => {
    const hiddenFileInput = useRef<HTMLInputElement>(null);
    const disabledClass = "border-gray-200 bg-gray-200 text-gray-400"
    const variantClass =
        disabled
            ? disabledClass
            : "border-accent-blue-pale bg-accent-blue-pale text-accent-blue-dark enabled:hover:bg-accent-blue-dark enabled:hover:text-white active:bg-accent-blue-pale enabled:focus:outline enabled:focus:-outline-offset-1 enabled:focus:outline-accent-blue-dark ring-accent-blue-pale";

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            if (onChange) {
                onChange(e.target.files[0])
            };
        }
    };

    const handleButtonClick = () => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.value= "";           
            hiddenFileInput.current.click();
        }
    }

    return (
        <div className={customWrapperClass}>
            <div className={`flex items-center justify-center ${buttonDimensionClass} rounded-lg border text-sm font-display font-semibold transition ${variantClass.includes('focus:outline') ? '' : 'focus:outline-none'} focus:ring ${variantClass}`}>
                <button onClick={handleButtonClick} disabled={disabled}>
                    {label}
                </button>
                <input
                    style={{ display: 'none' }}
                    id={id}
                    name={id}
                    type="file"
                    ref={hiddenFileInput}
                    accept={allowedFields ? `.${allowedFields.join(",.")}` : `.${APP_CONFIG.DOCUMENT_UPLOAD.ALLOWED_FILE_EXT.join(',.')}`} // accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.jpg,.jpeg,.png,"
                    onChange={handleFileChange}
                    disabled={disabled}
                />
            </div>
        </div>
    );
};